// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"dec4c112","1144":"3db5fcb7","1493":"505464fb","1723":"f48b4ef1","6914":"3db5fcb7","8693":"f48b4ef1"}[chunkId] + ".chunk.css";
};